import { useState } from "react";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { SecurityMeasureSaveModel, SecurityMeasureViewModel } from "./SecurityMeasures.types";

import { useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";

export const mapSecurityMeasureToSaveModel = (securityMeasure?: SecurityMeasureViewModel): SecurityMeasureSaveModel => ({
    name: securityMeasure?.name ?? "",
    description: securityMeasure?.description ?? "",
    securityMeasureType: securityMeasure?.securityMeasureType,
    isGlobal: securityMeasure?.isGlobal ?? false,
    isCustom: securityMeasure?.isCustom ?? false,
    businessAreaIds: securityMeasure?.businessAreaIds ?? [],
    groupEntitiesIds: securityMeasure?.groupEntitiesIds ?? [],
});

export function useSecurityMeasureMapping() {
    const queryClient = useDotLegalQueryClient();
    const [showAllSecurityMeasures, setShowAllSecurityMeasures] = useStateLocalStorage("onlyActiveSecurityMeasures", false);
    const [showAddEditDialog, setShowAddEditDialog] = useState(false);
    const [securityMeasureForDeletion, setSecurityMeasureForDeletion] = useState<SecurityMeasureViewModel | undefined>(undefined);
    const [selectedSecurityMeasure, setSelectedSecurityMeasure] = useState<SecurityMeasureViewModel | undefined>(undefined);
    const [securityMeasureForStatusChange, setSecurityMeasureForStatusChange] = useState<SecurityMeasureViewModel | undefined>(undefined);

    const queryPart = `?showAllSecurityMeasures=${showAllSecurityMeasures}`;
    const url = `/securityMeasures${queryPart}`;
    const { isLoading, data } = useDotLegalQuery<Array<SecurityMeasureViewModel>>(url);

    const securityMeasures = data ?? [];

    const refetchSecurityMeasures = () => {
        queryClient.refetchQueries(url);
    };

    return {
        isLoading,
        securityMeasures,
        showAllSecurityMeasures,
        setShowAllSecurityMeasures,
        showAddEditDialog,
        setShowAddEditDialog,
        securityMeasureForDeletion,
        setSecurityMeasureForDeletion,
        selectedSecurityMeasure,
        setSelectedSecurityMeasure,
        refetchSecurityMeasures,
        securityMeasureForStatusChange,
        setSecurityMeasureForStatusChange,
    };
}
